/**
 * Remove '+' character.
 *
 * @param {string || null} phoneNumber - phone number text.
 */
const normalizePhoneNumber = (phoneNumber) =>
  phoneNumber?.startsWith('+') ? phoneNumber?.slice(1) : phoneNumber ?? '';

export default normalizePhoneNumber;
